module.exports = __webpack_public_path__ + "static/media/icon-pdf.6875390e.svg";